import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { ASSIGN_USER_TO_BRAND_CURATION_TASK_MUTATION } from '../graphql/mutations'
import { ASSIGN_BRAND_CURATION_TASK_USER } from '../redux/action-types'

const useAssignUserToBrandCurationTaskMutation = (
  brandCurationTaskId,
  actionType,
) => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    userId =>
      apolloService.mutate({
        mutation: ASSIGN_USER_TO_BRAND_CURATION_TASK_MUTATION,
        variables: { id: brandCurationTaskId, userId, actionType },
        dispatch,
        action: ASSIGN_BRAND_CURATION_TASK_USER,
      }),
    [actionType, brandCurationTaskId, dispatch],
  )

  return [mutate]
}

export default useAssignUserToBrandCurationTaskMutation
